import clsx from 'clsx';

import Tooltip from 'layout/atoms/Tooltip';

import { ReactComponent as AlertIcon } from 'assets/icons/alert.svg';
import { ReactComponent as CheckIcon } from 'assets/icons/checkmark-circle.svg';
import { ReactComponent as EditIcon } from 'assets/icons/edit2.svg';
import { ReactComponent as QuestionIcon } from 'assets/icons/question-mark-circle.svg';

import styles from './iconHint.module.scss';

type IconHintVariant = 'info' | 'warning' | 'success' | 'error' | 'draft';
type IconHintSize = 's' | 'm' | 'l' | 'xl';

type IconHintProps = {
    variant: IconHintVariant;
    content: React.ReactNode;
    size?: IconHintSize;
    onClick?: () => void;
};

const iconMap: Record<
    IconHintVariant,
    React.FC<React.SVGProps<SVGSVGElement>>
> = {
    info: QuestionIcon,
    warning: AlertIcon,
    success: CheckIcon,
    error: AlertIcon,
    draft: EditIcon,
};

const IconHint: React.FC<IconHintProps> = ({
    variant,
    content,
    size = 'm',
    onClick,
}) => {
    const Icon = iconMap[variant];

    return (
        <Tooltip content={content}>
            <span
                className={clsx(styles.icon, styles[variant], styles[size])}
                onClick={onClick}
            >
                <Icon />
            </span>
        </Tooltip>
    );
};

export default IconHint;
